import identifyQualifiedTraffic from "@utils/identifyQualifiedTraffic";
import { handleCustomUDL } from "@utils/UDLUtils";

export class Text {
  private ctx: HTMLElement;
  private abortController = new AbortController();

  constructor(element: HTMLElement) {
    this.ctx = element;
  }

  init(): this {
    if (this.ctx.dataset.eventTracking !== "true") return this;

    const { signal } = this.abortController;
    this.ctx.querySelectorAll<HTMLAnchorElement>("a").forEach((link) => {
      link.addEventListener("click", (e) => {
        const el = e.currentTarget as HTMLAnchorElement;
        const link_url = el.href ?? "";
        const customParams = { ...this.ctx.dataset };
        delete customParams["component"]; //data-component
        delete customParams["tId"];
        delete customParams["eventTracking"];
        handleCustomUDL("text_link", {
          link_url,
          link_text: el.innerText ?? "",
          ...identifyQualifiedTraffic(link_url),
          ...customParams,
        });
      }, { signal });
    });
    return this;
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(): void {
    document
      .querySelectorAll<HTMLElement>('[data-component="text"]')
      .forEach((el) => new Text(el).init());
  }
}
